import React from "react";
import { useField, useFormikContext } from "formik";

interface Props {
  name: string;
}

const SelectErrorMessage: React.FC<Props> = ({ name }) => {
  const [field, meta] = useField(name);
  const { submitCount } = useFormikContext();
  if ((meta.touched || submitCount > 0) && meta.error) {
    return <div className="invalid-feedback d-block">{meta.error}</div>;
  }
  return null;
};

export default SelectErrorMessage;